export default __webpack_public_path__ + "static/media/client-logo-5.0f0810bd.png";